export class Role {
  value: string;
  label?: string;

  constructor(value: string, label: string) {
    this.value = value;
    this.label = label;
  }
}
